import { Injectable } from '@angular/core';
import { NeqTableFilterAndSort } from '@sharedcommon/components/table/neq-table-request.model';
import { EntityDto } from '@sharedcommon/rest/identity.restservice';
import {NeqLocalStorageService} from '@sharedcommon/services/neq-local-storage.service';

const USER_ENTITY_KEY = 'equadvice-user-entity';
class StoredUserInfomation { 
  activity: string;
  operatingMode: string;
  entity: EntityDto;
}

@Injectable()
export class UserStore {

  constructor(private readonly neqLocalStorageService: NeqLocalStorageService) {}

  setUserEntity(storedUser: StoredUserInfomation) {
    if (storedUser?.entity?.associatedEntities) {
      /* Delete useless information to do not stored large information in the local storage */
      delete(storedUser.entity.associatedEntities); 
    }
    this.neqLocalStorageService.setItem(USER_ENTITY_KEY, btoa(JSON.stringify(storedUser)));
  }

  getUserEntity(): StoredUserInfomation {
    const stored = this.neqLocalStorageService.getItem(USER_ENTITY_KEY);
    let result = null;
    if (stored) {
      try {
        result = JSON.parse(atob(stored));
      } catch (e) {
        this.neqLocalStorageService.removeItem(USER_ENTITY_KEY);
      }
    }
    return result;
  }

  removeUserEntity() {
    this.neqLocalStorageService.removeItem(USER_ENTITY_KEY);
  }

  clear() {
    this.neqLocalStorageService.clear();
  }

  setPageFilter(key:string, value:NeqTableFilterAndSort) {
    this.neqLocalStorageService.setObjectItem(key, value);
  }

  getPageFilter(key:string): NeqTableFilterAndSort {
    return this.neqLocalStorageService.getObjectItem(key);
  }

  removePageFilter(FilterToRemove:string) {
    this.neqLocalStorageService.removeItem(FilterToRemove);
  }
}
